import { render, staticRenderFns } from "./list-appointment.vue?vue&type=template&id=4aa7498a"
import script from "./list-appointment.vue?vue&type=script&lang=js"
export * from "./list-appointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports